import { saveApplicationUagsage } from "../services/sharedServices";

const applicationUsageLog = (UsedBy, UsedByEmail, AppName, ModuleName) => {
  saveApplicationUagsage(UsedBy, UsedByEmail, AppName, ModuleName);
};

export default applicationUsageLog;
